import React from 'react';
import { createIcon } from '@chakra-ui/react';

const UtensilsIcon = createIcon({
  displayName: 'UtensilsIcon',
  viewBox: '0 0 12 12',
  path: (
    <path
      d='M3.36385 6.74573L5.13992 4.87534L0.734274 0.242329C-0.244758 1.27336 -0.244758 2.94547 0.734274 3.9831L3.36385 6.74573ZM7.61888 5.54947C8.57908 6.01872 9.92839 5.68826 10.9263 4.63741C12.1249 3.37506 12.3571 1.56416 11.4346 0.592614C10.5183 -0.372322 8.79874 -0.134393 7.59378 1.12795C6.59592 2.17881 6.28212 3.59977 6.72771 4.61097L0.602481 11.0615L1.48738 11.9934L5.81144 7.45291L10.1292 12L11.0141 11.0681L6.69633 6.52102L7.61888 5.54947Z'
      fill='currentColor'
    />
  ),
});

export default UtensilsIcon;
